import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import UpgradeButton from '../UpgradeButton'


const handleClick = (placement, snowplowPlacement) => () => {
  snowplow.track(constants.snowplowEvents.upgradeSubscriptionClick, { placement: snowplowPlacement }, false)
  actions.models.subscription.handleUpgradeClick({ placement })
}

const OpenUpgradeButton = (props) => {
  const {
    id, className, disabled, color, size,
    placement, snowplowPlacement, fullWidth,
    dataTestId,
  } = props

  return (
    <UpgradeButton
      id={id}
      className={className}
      size={size}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      dataTestId={dataTestId}
      onClick={handleClick(placement, snowplowPlacement)}
    />
  )
}

OpenUpgradeButton.propTypes = {
  placement: PropTypes.string.isRequired,
  snowplowPlacement: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
}

OpenUpgradeButton.defaultProps = {
  color: 'brand',
  size: 'md',
}


export default OpenUpgradeButton
